<template>
  <ApolloQuery
    :query="
      (gql) => gql`
        query Story($storyId: ID!, $userId: String) {
          story(id: $storyId) {
            id
            name
            summary
            priceCents
            socialLink {
              image {
                contentUrl
              }
            }
            coverArt {
              id
              contentUrl
            }
            userLibraryStories(first: 1, id: $userId) {
              totalCount
            }
            storyPurchases(owner_id: $userId, exists: { paidAt: true }) {
              id
              paidAt
            }
          }
        }
      `
    "
    :variables="{ storyId: idWithIri, userId: userIdWithIri }"
  >
    <template v-slot="{ result: { error, data }, query }">
      <v-container>
        <v-row v-if="!data">
          <v-col>
            <v-skeleton-loader type="card" />
          </v-col>
        </v-row>
        <v-row v-else-if="data && data.story">
          <v-col>
            <v-row>
              <v-col>
                <StepHeader>{{ data.story.name }} </StepHeader>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <StoryCoverArt :coverArt="data.story.coverArt" />
              </v-col>
            </v-row>
            <v-row>
              <v-col>{{ data.story.summary }}</v-col>
            </v-row>
            <v-row v-if="data.story.priceCents">
              <v-col
                ><h2>
                  ${{ (data.story.priceCents / 100).toFixed(2) }} CAD
                </h2></v-col
              >
            </v-row>
            <v-row
              v-if="
                data.story.userLibraryStories.totalCount > 0 ||
                data.story.storyPurchases.length > 0
              "
            >
              <v-col
                ><v-alert class="mx-auto" width="300" type="info">{{
                  $t("store.thisStoryIsInYourLibrary")
                }}</v-alert></v-col
              >
            </v-row>
            <v-row v-else-if="data.story.priceCents">
              <v-col
                ><PurchaseStoryButton
                  :idWithIri="idWithIri"
                  :activate="forwardImmediately"
              /></v-col>
            </v-row>
            <v-row v-else-if="data.story.userLibraryStories.totalCount == 0">
              <v-col
                ><AddToLibraryButton
                  @added="
                    query.refetch();
                    tempStoryInLibrary = true;
                  "
                  :idWithIri="idWithIri"
              /></v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row v-if="error">
          <v-col>
            {{ error }}
          </v-col>
        </v-row>
      </v-container>
    </template>
  </ApolloQuery>
</template>
<script>
import iris from "@/iris";
import StoryCoverArt from "@/components/Reusable/StoryCoverArt";
import PurchaseStoryButton from "@/views/PurchaseStory/PurchaseStoryButton.vue";
import AddToLibraryButton from "@/views/PurchaseStory/AddToLibraryButton.vue";
import hasLoggedInUser from "@/mixins/hasLoggedInUser";
import StepHeader from "@/components/Reusable/StepHeader.vue";
export default {
  mixins: [hasLoggedInUser],
  name: "PurchaseStory",
  data() {
    return {
      tempStoryInLibrary: false,
    };
  },
  components: {
    AddToLibraryButton,
    PurchaseStoryButton,
    StoryCoverArt,
    StepHeader,
  },
  computed: {
    forwardImmediately() {
      return this.$route.query.buyNow && this.user ? true : false;
    },
    storyId() {
      return this.$route.params.id;
    },
    storyIri() {
      return iris.story;
    },
    idWithIri() {
      return this.storyIri + this.storyId;
    },
    userIdWithIri() {
      if (this.user) {
        return this.user.id;
      }
      return null;
    },
  },
};
</script>
